import { EmploymentApiModel } from '../../../api/targeting/model/targeting-search-result.api.model';
import { JobRoleModel } from '../../Core/models/job-role.model';
import { OutletModel } from './outlet.model';

export class EmploymentModel {
    id?: number;
    jobTitle?: string;
    jobRoles?: JobRoleModel[] = [];
    outlet?: OutletModel;

    startDate?: Date;

    constructor(apiModel?: EmploymentApiModel) {
        if (apiModel) {
            this.id = +apiModel.id;
            this.jobTitle = apiModel.jobTitle;
            this.jobRoles = apiModel.jobRoles?.map(x => new JobRoleModel(x));
            if (apiModel.outletInfo) {
                this.outlet = new OutletModel(apiModel.outletInfo);
            }
            this.startDate = apiModel.startDate ? new Date(apiModel.startDate) : null;
        }
    }

    toApiModel(): EmploymentApiModel {
        const apiModel: EmploymentApiModel = {
            jobTitle: this.jobTitle?.trim(),
            id: !!this.id ?  '' + this.id : undefined,
            jobRoles: this.jobRoles.map(x => {
                return {
                    id : x.id
                };
            }),
        };
        if (this.outlet) {
            // Api expects outletInfo to be filled, or undefined. We have to use either id or name
            // if no other info, else leave it undefined
            if (this.outlet.id) {
                apiModel.outletInfo = {id: this.outlet.id};
            } else if (this.outlet.name) {
                // Hack... this is what the prime autocomplet puts in the outlet if
                // you don't select a system outlet from the suggestions
                // we're probably not gonna use the autocomplete in the long run
                apiModel.outletInfo = {name: this.outlet.name};
            }
        }
        return apiModel;
    }

    clone(): EmploymentModel {
        const clone = new EmploymentModel(this.toApiModel());
        clone.outlet = this.outlet?.clone();
        clone.startDate = this.startDate;
        clone.jobRoles = this.jobRoles.map(jobRole => jobRole.clone());
        return clone;
    }
}
